module.exports = __webpack_public_path__ + "static/media/Emily Tsai.99687241.png";